// components/common/modal/ModalContent.tsx
import React from 'react';
import { DialogContent, DialogContentProps, styled } from '@mui/material';

const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
    padding: theme.spacing(2),
    '& .MuiFormControl-root + .MuiFormControl-root': {
        marginTop: theme.spacing(2),
    },
    flexGrow: 1,
    overflow: 'auto', // Create scrollable region when content exceeds available space
    minHeight: '100px', // Ensure a minimum height
    display: 'flex',
    flexDirection: 'column',
}));

interface ModalContentProps extends DialogContentProps {
    children: React.ReactNode;
}

export const ModalContent = ({ children, ...props }: ModalContentProps) => {
    return (
        <StyledDialogContent dividers {...props}>
            {children}
        </StyledDialogContent>
    );
};
